// 9fbef606107a605d69c0edbcd8029e5d
import { DEFAULT_REDUCER_KEY, setCacheTTL } from '@tcp/core/src/utils/cache.util';
import { PROMOTIONS_CONSTANT } from './Promotions.constants';

const initialState = {
  promotionsData: {},
  promotionsDetails: {},
  appliedPromotion: [],
  removedPromotions: [],
  [DEFAULT_REDUCER_KEY]: null,
  offerTypeBasedPromotion: {},
};

const promotionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PROMOTIONS_CONSTANT.SET_ALL_PROMOTIONS:
      return {
        ...state,
        promotionsData: payload,
      };
    case PROMOTIONS_CONSTANT.SET_PROMOTIONS_DETAILS:
      return {
        ...state,
        promotionsDetails: {
          ...state.promotionsDetails,
          ...payload,
          [DEFAULT_REDUCER_KEY]: setCacheTTL(3600000),
        },
      };
    case PROMOTIONS_CONSTANT.SET_APPLIED_PROMOTION:
      if (!state?.appliedPromotion.includes(payload)) {
        return {
          ...state,
          appliedPromotion: [...state.appliedPromotion, payload],
          removedPromotions: state?.removedPromotions?.filter((promo) => promo !== payload),
        };
      }
      return { ...state };
    case PROMOTIONS_CONSTANT.REMOVE_APPLIED_PROMOTION:
      if (!state?.removedPromotions.includes(payload)) {
        return {
          ...state,
          appliedPromotion: state?.appliedPromotion?.filter((promo) => promo !== payload),
          removedPromotions: [...state.removedPromotions, payload],
        };
      }
      return { ...state };
    case PROMOTIONS_CONSTANT.SET_CACHED_PROMOTIONS:
      return {
        ...state,
        cachedPromotions: payload,
      };
    case PROMOTIONS_CONSTANT.UPDATE_CHECKBOX:
      return {
        ...state,
        updateCheckbox: payload,
      };
    case PROMOTIONS_CONSTANT.RESET_APPLIED_PROMOTIONS:
      return {
        ...state,
        appliedPromotion: payload,
      };
    case PROMOTIONS_CONSTANT.RESET_REMOVED_PROMOTIONS:
      return {
        ...state,
        removedPromotions: payload,
      };
    case PROMOTIONS_CONSTANT.SET_ALL_OFFER_TYPE_BASED_PROMOTIONS_DATA:
      return {
        ...state,
        offerTypeBasedPromotion: payload,
      };
    default:
      return state;
  }
};

export default promotionsReducer;
